<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M11.5 5.53125C11.5 2.51094 13.9484 0.0625 16.9688 0.0625C17.5199 0.0625 18.0534 0.144289 18.557 0.296924C18.8198 0.37657 19.0215 0.588322 19.0882 0.85467C19.155 1.12102 19.077 1.40285 18.8828 1.59701L15.4259 5.05399C15.4901 5.54939 15.7123 6.02689 16.0927 6.40728C16.4731 6.78767 16.9506 7.00987 17.446 7.07413L20.903 3.61716C21.0971 3.423 21.379 3.34502 21.6453 3.41177C21.9117 3.47852 22.1234 3.6802 22.2031 3.94298C22.3557 4.44657 22.4375 4.98006 22.4375 5.53125C22.4375 8.55156 19.9891 11 16.9688 11C16.812 11 16.6566 10.9934 16.5028 10.9804C15.4432 10.8908 14.556 11.085 14.0984 11.6408L6.64924 20.6861C5.99671 21.4785 5.02404 21.9375 3.99759 21.9375C2.10044 21.9375 0.5625 20.3996 0.5625 18.5024C0.5625 17.476 1.02153 16.5033 1.81388 15.8508L10.8592 8.40164C11.415 7.94399 11.6092 7.0568 11.5196 5.99717C11.5066 5.84342 11.5 5.68802 11.5 5.53125ZM3.28879 18.4219C3.28879 17.9904 3.63856 17.6407 4.07004 17.6407H4.07785C4.50932 17.6407 4.8591 17.9904 4.8591 18.4219V18.4297C4.8591 18.8612 4.50932 19.211 4.07785 19.211H4.07004C3.63856 19.211 3.28879 18.8612 3.28879 18.4297V18.4219Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgIcons8Support',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>